// Vat Module Initialization
// This file contains all side effects for the vat module.
// It is imported by src/imports.ts at application startup.

import { VAT_REPORT } from '@/vat'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { NavGroup, registerNavigationEntry } from '@/navigation'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb } = useBreadCrumbs()

const icon = 'i-ph-percent'
const label = 'MVA-melding'
const hotkey = 'd'

// VAT_REPORT
registerRoute(VAT_REPORT)

registerNavigationCommand({
    route: VAT_REPORT,
    label,
    icon,
    hotkey
})

registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'vat-report',
    icon,
    target: VAT_REPORT,
    sortOrder: 11
})

buildSimpleCrumb(VAT_REPORT, label, icon, true)
